module.exports = __webpack_public_path__ + "static/media/onboardingCar.7c01d6b5.png";